import { Injectable } from '@angular/core';
import { BehaviorSubject, combineLatest, Observable } from 'rxjs';
import { LocalStorageService } from '@shared/services/local-storage.service';
import { filter, map } from 'rxjs/operators';
import { THEMES } from '@shared/config';
import { UserSettings } from '@shared/models/user-settings.model';

@Injectable({
  providedIn: 'root',
})
export class UserSettingsStateService {
  private theme = new BehaviorSubject<THEMES>(
    THEMES[LocalStorageService.getTheme() || THEMES.dark]
  );
  private userSettingsId = new BehaviorSubject(
    LocalStorageService.getUserSettingsId()
  );

  public theme$ = this.theme.asObservable();
  public userSettingsId$ = this.userSettingsId
    .asObservable()
    .pipe(filter(id => id != null && id != undefined));

  public setTheme(theme: THEMES) {
    LocalStorageService.setTheme(theme);
    this.theme.next(theme);
  }

  public setUserSettingsId(userSettingsId: number) {
    LocalStorageService.setUserSettingsId(userSettingsId);
    this.userSettingsId.next(userSettingsId);
  }

  public getUserSettings(): Observable<UserSettings> {
    return combineLatest([this.userSettingsId$, this.theme$]).pipe(
      map(([userSettingsId, theme]) => ({ userSettingsId, theme })),
      map(userSettings => ({
        ...userSettings,
        theme: THEMES[userSettings.theme],
      }))
    );
  }
}
